import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
var _excluded = ["onStateChange"];
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useRef, useState, useCallback, useEffect } from 'react';
import { useCombobox } from 'downshift';
import { defaultMinChars } from '../../utils/defaults';
import { debounce, identity, isFunction } from 'lodash';
var EMPTY_INPUT = 0;
export function useItems(_ref) {
  var _ref$minChars = _ref.minChars,
      minChars = _ref$minChars === void 0 ? defaultMinChars : _ref$minChars,
      _ref$debounce = _ref.debounce,
      propDebounce = _ref$debounce === void 0 ? 200 : _ref$debounce,
      getItems = _ref.getItems,
      getSuggestedItems = _ref.getSuggestedItems;
  var suggestedItems = useRef(null);

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      items = _useState2[0],
      setItems = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isOpen = _useState4[0],
      setIsOpen = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      searchInputValue = _useState6[0],
      setSearchInputValue = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedItems = _useState8[0],
      setSelectedItems = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isLoading = _useState10[0],
      setIsLoading = _useState10[1];

  var _useState11 = useState(null),
      _useState12 = _slicedToArray(_useState11, 2),
      helperText = _useState12[0],
      setHelperText = _useState12[1];

  var isOpenRef = useRef(isOpen);
  isOpenRef.current = isOpen;
  var shouldRenderSuggestedItems = getSuggestedItems && searchInputValue.length < minChars && searchInputValue.length === EMPTY_INPUT;

  var _onStateChange = useCallback(function (changes) {
    var type = changes.type,
        isOpen = changes.isOpen,
        inputValue = changes.inputValue,
        selectedItems = changes.selectedItems; // Synchronise the isOpen state from the select

    if (changes.hasOwnProperty('isOpen')) {
      setIsOpen(isOpen);
    }

    if (changes.hasOwnProperty('selectedItems')) {
      setSelectedItems(selectedItems);
    } // When other state changes happen, if the search value
    // hasn't triggered a search yet then we need to reset it


    if (searchInputValue.length < minChars) {
      setSearchInputValue('');
    } // Our input value is purely used to update the idle text
    // and item state, so we only update it when we want either
    // of these to change


    switch (type) {
      case useCombobox.stateChangeTypes.InputChange:
        setSearchInputValue(inputValue);
        break;

      default:
        break;
    }
  }, [minChars, searchInputValue]);

  var getSelectProps = useCallback(function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var passedOnStateChange = _ref2.onStateChange,
        args = _objectWithoutProperties(_ref2, _excluded);

    return _objectSpread(_objectSpread({}, args), {}, {
      items: items,
      helperText: helperText,
      // The default behaviour when fetching items
      // from an API should be to return everything
      filter: identity,
      onStateChange: function onStateChange(changes) {
        _onStateChange(changes);

        passedOnStateChange === null || passedOnStateChange === void 0 ? void 0 : passedOnStateChange(changes);
      }
    });
  }, [items, helperText, _onStateChange]);
  var resolveItems = useCallback(debounce(function (_ref3, callback) {
    var inputValue = _ref3.inputValue,
        signal = _ref3.signal,
        resolver = _ref3.resolver;
    // Because this function is debounced, if we return a promise here
    // then the function in the useEffect below will return that same
    // promise that has been cancelled already
    // This way we can create a new promise and resolve with the correct
    // callback function after the debounce delay
    var promise = new _Promise(function (resolve) {
      if (isFunction(resolver)) {
        _Promise.resolve(inputValue ? resolver(inputValue, {
          signal: signal
        }) : resolver({
          signal: signal
        })).then(function (items) {
          if (!signal.aborted) {
            setItems(items !== null && items !== void 0 ? items : []);
            setIsLoading(false);
          }

          resolve(items !== null && items !== void 0 ? items : []);
        });
      }
    });
    promise.then(callback);
  }, propDebounce, // NOTE: the `leading` option prevents selects with no debounce to jitter because
  // of a `0s` debounce (which still puts the callback into the queue and executes it
  // on the next tick of the thread)
  {
    leading: propDebounce === 0,
    trailing: true
  }), []);
  useEffect(function () {
    if (!isOpen) {
      return;
    }

    if (searchInputValue.length >= minChars) {
      var controller = new AbortController();
      var signal = controller.signal;
      setItems([]);
      setIsLoading(true);
      resolveItems({
        inputValue: searchInputValue,
        signal: signal,
        resolver: getItems
      });
      return function () {
        setIsLoading(false);
        controller.abort();

        if (isOpenRef.current) {
          setItems([]);
        }
      };
    } // Don't run this effect when the `isOpen` state changes
    // so that we keep the old results around (we also don't
    // update the `inputValue` when the menu state changes)
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [minChars, searchInputValue, resolveItems, getItems]);
  useEffect(function () {
    // Invalidate suggested items cache when the
    // getSuggestedItems prop changes
    suggestedItems.current = null;
  }, [getSuggestedItems]);
  useEffect(function () {
    if (!isOpen) {
      return;
    }

    if (shouldRenderSuggestedItems) {
      var controller = new AbortController();
      var signal = controller.signal; // When we already have cached items just set them

      if (suggestedItems.current) {
        setItems(suggestedItems.current);
      } else {
        setItems([]);
        setIsLoading(true); // Otherwise fetch new suggested items

        resolveItems({
          signal: signal,
          resolver: getSuggestedItems
        }, function (newSuggestedItems) {
          suggestedItems.current = newSuggestedItems;
        });
      }

      return function () {
        setIsLoading(false);
        controller.abort();

        if (isOpenRef.current) {
          setItems([]);
        }
      };
    }
  }, [isOpen, shouldRenderSuggestedItems, resolveItems, getSuggestedItems]);
  useEffect(function () {
    if (isLoading) {
      return setHelperText(shouldRenderSuggestedItems ? 'Loading suggested items...' : 'Loading...');
    }

    if (searchInputValue.length < minChars) {
      return setHelperText(shouldRenderSuggestedItems ? // Fall back to default behaviour if there are any
      // items defined in a multi select
      selectedItems.length > 0 ? null : 'Suggested items' : "Please type ".concat(minChars - searchInputValue.length, " more characters to search"));
    }

    setHelperText(null);
  }, [minChars, items, searchInputValue, isLoading, selectedItems, shouldRenderSuggestedItems]);
  return {
    getSelectProps: getSelectProps
  };
}